import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=2dd9af2e"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"
import style0 from "./Payment.vue?vue&type=style&index=0&id=2dd9af2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports